import { LOGGER } from "../utils/logger";
import useAxios from "../utils/interceptor";

const CompanyApi = () => {
  const axiosHandler = useAxios();

  const getAll = async () => {
    try {
      const res = await axiosHandler.get(`company/all-company`);
      return res?.data;
    } catch (error) {
      LOGGER.error({ text: "getAll api ", error });
    }
  };

  //   const create = async (body) => {
  //     try {
  //       const res = await axiosHandler.post(`customer`, body);
  //       return res;
  //     } catch (error) {
  //       LOGGER.error({ text: "create api ", error });
  //     }
  //   };

  const getCompanyDetail = async (body) => {
    try {
      const res = await axiosHandler.post(`company/company-detail`, body);
      return res?.data;
    } catch (error) {
      LOGGER.error({
        text: "get api company",
        error,
      });
    }
  };

  return {
    getAll,
    getCompanyDetail,
  };
};

export default CompanyApi;
